module.exports = __webpack_public_path__ + "img/product-guide.6d519b83.png";